// Admin routes for P7-E (AUTOMATION-01…04). Owned by that worker; the router mounts
// whatever this returns under the app shell (before the store-area placeholder), so modules never
// edit router.tsx. Paths follow IA §2.1:
//   …/marketing/automations   AUTOMATION-01/02/04 flows (nav "Automations", automations.manage)
//   …/marketing/messages      AUTOMATION-03 segment campaigns (nav "Messages", campaigns.send)
import {
  createRoute,
  type AnyRoute,
  type RouteComponent,
  lazyRouteComponent,
} from "@tanstack/react-router";

// Pages are code-split: each loads when its route opens, not with the shell.
const load1 = () => import("../automation/AutomationsPage");
const AutomationsPage = lazyRouteComponent(load1, "AutomationsPage");
const load2 = () => import("../campaigns/CampaignsPage");
const CampaignsPage = lazyRouteComponent(load2, "CampaignsPage");

export function automationRoutes(appRoute: AnyRoute): AnyRoute[] {
  const at = (path: string, component: RouteComponent) =>
    createRoute({ getParentRoute: () => appRoute, path, component }) as unknown as AnyRoute;
  return [
    at("/$org/$store/marketing/automations", AutomationsPage),
    at("/$org/$store/marketing/messages", CampaignsPage),
  ];
}
